// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioButtonGroup_root__2-3P1","smaller":"RadioButtonGroup_smaller__ZYQJy"};